module.exports = __webpack_public_path__ + "static/media/hockey-sticks.cff7a712.svg";